// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8394bd07","455":"ffb4578c","977":"38279bb9"}[chunkId] + ".chunk.js";
};